module.exports = __webpack_public_path__ + "img/45.9841c5d5.webp";